import { useState, type ReactNode } from 'react';
import DashboardSidebar from '@/components/feature/DashboardSidebar';
import DashboardTopbar from '@/components/feature/DashboardTopbar';

interface DashboardLayoutProps {
  title: string;
  children: ReactNode;
}

export default function DashboardLayout({ title, children }: DashboardLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background-50">
      <DashboardSidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((prev) => !prev)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      <div
        className={[
          'flex min-h-screen flex-col transition-all duration-300',
          collapsed ? 'lg:ms-[72px]' : 'lg:ms-[260px]',
        ].join(' ')}
      >
        <DashboardTopbar title={title} onOpenMobileSidebar={() => setMobileOpen(true)} />
        <main className="flex-1 px-4 py-6 md:px-6">
          <div className="mx-auto w-full max-w-content">{children}</div>
        </main>
      </div>
    </div>
  );
}